module.exports = __webpack_public_path__ + "images/plan-details.9b8bc060ec2edbfa6be729eb22e65eca.png";